import {Table} from 'antd';
import React from 'react';

import {CustomLink} from 'features/provide-custom-link';
import {ECustomLinkModalTableColumnType} from 'features/provide-custom-link/model/constants';
import {TCustomLinkModalTableColumn} from 'features/provide-custom-link/model/types';
import {TLinkDto, ELinkType} from 'shared/types/links';

import {FileWithToken} from './columns/file-with-token/file-with-token';
import s from './custom-link-modal-table-view.module.less';

interface ICustomLinkModalTableViewProps {
    columns: TCustomLinkModalTableColumn[];
    tableData?: Record<string, string | number>[];
}

export const CustomLinkModalTableView = ({
    columns,
    tableData,
}: ICustomLinkModalTableViewProps) => (
    <Table
        rowKey="id"
        className={s['custom-link-modal-table-view']}
        dataSource={tableData}
        columns={columns.map(col => ({
            dataIndex: col.key,
            key: col.key,
            title: col.title,
            render: v => {
                switch (col.type) {
                case ECustomLinkModalTableColumnType.LINK: {
                    return (
                        <a
                            target="_blank"
                            href={v}
                            rel="noopener noreferrer"
                        >{v}
                        </a>
                    );
                }
                case ECustomLinkModalTableColumnType.FILE_WITH_TOKEN: {
                    return <FileWithToken url={v} />;
                }
                case ECustomLinkModalTableColumnType.CUSTOM_URL: {
                    const link = v as TLinkDto;

                    // против циклических CustomLink
                    if (link?.urlType === ELinkType.SUBMENU) {
                        console.error('Тип ссылки SUBMENU внутри модального окна не поддерживается');
                        return '-';
                    }
                    return <CustomLink link={link} />;
                }
                default:
                    return v;
                }
            },
        }))}
    />
);
